import { ContractChangeStatusEnum } from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';
import { Badge } from 'uikit';

import type { CSSProperties } from 'react';

import Styles from './AgreementsStatus.module.css';

export const statusProps: Record<ContractChangeStatusEnum, { label: string; status: BadgePropStatus }> = {
    [ContractChangeStatusEnum.Formation]: { label: 'На формировании', status: 'normal' },
    [ContractChangeStatusEnum.Approving]: { label: 'На согласовании', status: 'warning' },
    [ContractChangeStatusEnum.Approved]: { label: 'Согласован', status: 'success' },
    [ContractChangeStatusEnum.Delayed]: { label: 'Отложен', status: 'system' },
};

export const AgreementsStatus = ({
    statusKey,
    isMinified = false,
    style,
}: {
    statusKey: ContractChangeStatusEnum;
    isMinified?: boolean;
    style?: CSSProperties;
}) => <Badge className={Styles[statusKey]} {...statusProps[statusKey]} minified={isMinified} style={style} />;

AgreementsStatus.displayName = 'AgreementsStatus';
